import { render, staticRenderFns } from "./DppEditor.vue?vue&type=template&id=464fe6ee&scoped=true"
import script from "./DppEditor.vue?vue&type=script&lang=js"
export * from "./DppEditor.vue?vue&type=script&lang=js"
import style0 from "./DppEditor.vue?vue&type=style&index=0&id=464fe6ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464fe6ee",
  null
  
)

export default component.exports